import React from "react";

export default function ChildPriPol() {
  return (
    <>
      <h1>Children’s Privacy Policy</h1>
      <a
        href="https://empass.mobi/privacypolicy"
        rel="noreferrer noopener"
        target="_blank"
      >
        Click here for detailed privacy policy
      </a>
      <br />
      <span>Last Updated: July 1, 2019</span>
      <br />
      <p>
        Empass Learning (also referred to as “Empass”, “we”, “us”, or “our”
        herewith) understands the need to provide strict privacy protection with
        respect to the Personal Information collected from children under 13
        years of age (“child” or “children”) while they interact with us or use
        our Services. This Children’s Privacy Policy documents our information
        collection, use, disclosure, and parental consent practices with respect
        to the Personal Information we collect from children, and it is a part
        of and uses terms that are defined in our general Privacy Policy.
        <br />
        This Children’s Privacy Policy supersedes any conflicting provision that
        might be already covered in our general Privacy Policy. Usage of the
        terms “parent” or “parental” shall include legal guardians.
      </p>

      <ol>
        <li>
          <p>
            <h3>
              The Personal Information We Collect from Children, How We Use It,
              And How and When We Seek Parental Consent
            </h3>
            We market and sell our products to adults who purchase or otherwise
            subscribe to our Services. Some of our products and services can
            then be used by children at the direction and under the supervision
            of these adults. Some of our Services—Empass Assess, Empass FreXP,
            and Empass Amaze offer online learning and assessment tools that
            children may access. These tools may collect Personal Information
            from children, as defined by COPPA. Below, we provide a list of
            likely situations of such collection and describe how and when we
            will provide parental notice and seek prior verifiable parental
            consent.
            <br />
            We do not knowingly collect, use, disclose or store any Personal
            Information from children unless we have obtained prior verifiable
            parental consent. In any instance where we collect Personal
            Information from a child, we will not collect more Personal
            information than is reasonably necessary for the child to
            participate in the Service, and we will retain that information only
            as long as reasonably necessary to fulfill the request or allow the
            child to participate in the Service, ensure the security of our
            users and Services, or as required by law. In the event that we
            discover that we have inadvertently collected information from a
            child in a manner inconsistent with COPPA’s requirements, we will
            delete that information and attempt to notify the child’s parent. If
            you believe that we might have collected Personal Information from
            your child without consent, please <a href=""> contact us </a>
          </p>
        </li>
      </ol>

      <p>
        Account Creation and Child Login Credentials <br />
        As described in our general Privacy Policy set forth above, we do not
        allow children to purchase or otherwise subscribe to any Service: our
        account creation feature is intended strictly for adult teachers,
        assessors or parent use, and we take measures to make this apparent in
        order to prevent children from submitting Personal Information to our
        Service in this manner.
        <br />
        An adult teacher or parent purchaser of any Service may open an account
        for a child by creating the child’s login credentials. We collect
        child’s user credentials each time a child log in to the app or platform
        to access the Services. We will not use this information for any purpose
        other than authenticating the child’s login and facilitating access to
        the Services. Our staff is not authorized to access or disclose child’s
        login information as most of it is programmatically collected and
        administered. Any information regarding child’s login credentials is
        strictly controlled by their teacher or authorized assessor who is
        responsible for creating the child’s account.
        <br />
        Communicating With Us
        <br />
        As described in our general Privacy Policy set forth above, we collect
        and retain Personal and Non Personal Information from users who choose
        to send us an email or chat with us via our website or when you sign up
        for a newsletter on our website. Children are not permitted to
        communicate with us directly using these means, and we take measures to
        make this apparent in order to prevent children from submitting Personal
        Information to us in this manner.
        <br />
        Nevertheless, if a child does communicate with us, we will collect the
        child’s Personal Information to directly respond to the child’s request
        for assisting them on a one-time basis, and we will delete the child’s
        Personal Information after responding.
        <br />
        Automated Information
        <br />
        We automatically receive and record certain technical information from a
        child’s browser, including the child’s IP address, for internal purposes
        only. When we collect an IP address, we combine it with other
        information submitted by the user’s browser, such as requests for files
        from the web server. This information is used to generate analytics
        reports, create access logs, which are used for analyzing user types and
        locations, determining trends (e.g. which pages are used the most, which
        browsers are most frequently used by visitors to access the site, and
        which areas of the world site users are accessing our products from most
        frequently). Our access logs do not contain any information which can be
        uniquely associated with any particular IP address or Personal
        Information about any individual user.
        <br />
        Children Account Activity
        <br />
        Certain activities on certain Services allow children to create or
        manipulate content and save it on our Services. Some of these activities
        do not require children to provide any Personal Information. If a
        Service requests or allows a child to provide Personal Information in
        their created content, we will seek prior verifiable parental consent in
        order to collect that information. Examples of created content that
        constitutes or may include Personal Information include the following:
      </p>
      <ul>
        <li>
          Voice and video recordings (Empass Amaze, Empass FreXP): Children may
          record their speech while reading texts, speaking in response to an
          on-screen question and also record themselves using their mobile video
          cameras when prompted for specific assessments. They may also be
          playing their recordings back, and they may send the recordings to our
          servers for further processing and review. Learning languages and
          identifying learning disabilities or gifted capabilities is a core of
          these two products.
        </li>
        <li>
          Free-form text field (Empass Amaze, Empass FreXP): Children may draft
          and submit typed responses to various prompts (assessment questions).
        </li>
      </ul>
      <p>
        We do not use children video or voice recordings or the information
        provided by children in free-form text fields for any internal purpose;
        we only transmit the voice recordings and the content provided in
        free-form text-fields for analysis, scoring and review by certified
        assessors or teachers. Children may not share their video or voice
        recordings or the information provided in free-form text fields with
        anyone else, and they cannot privately communicate with anyone using the
        Service.
        <br />
        Additional educational information is collected as the child progresses
        through the Service, such as amount of time logged in, reading rate, and
        assessment scores. This information allows the Service to adapt to the
        child and inform the assessors of the children to rate and review their
        performance.
        <br />
        Consent—Parents
        <br />
        For parent purchasers, in the event we wish to collect the Personal
        Information outlined above from a child, we provide parental notice and
        seek verifiable parental consent via the email address provided during
        account creation. In our initial email, we describe what Personal
        Information we collect from children, how we collect it, how we use it,
        how we disclose it, how the parent can consent to the collection of such
        information, and your parental rights over such information. This email
        contains an activation link you must click. We send another email
        message to confirm we have obtained consent after a reasonable time
        delay. In this confirmatory message, we indicate how the parent can
        revoke consent to our collection of Personal Information.
        <br />
        Consent—Schools As Agents of Parents
        <br />
        Where a school or school state/district contracts with us to offer the
        Services solely for the benefit of their children and for the school
        system and for no other commercial purpose, the school or school
        district may consent to the collection of children’s Personal
        Information on their parents’ behalf. We encourage schools and school
        districts using our Services to notify parents that our Services are
        being used in their schools.
        <br />
        We provide the schools and school districts using our Services with the
        notices required under COPPA, including a description of the Personal
        Information we collect from children, how we collect it, how we use it,
        how we disclose it, how the school or school district can consent to the
        collection of such information, and all other rights over such
        information.
      </p>
      <ol>
        <li>
          <p>
            How We Share Personal Information Collected From Children We do not
            provide any child’s Personal Information to third parties—we use
            this information for internal purposes only.
          </p>
        </li>
        <li>
          <p>
            Parental and School Access and Control Over Personal Information
            Collected From Children
          </p>
        </li>
      </ol>
      <p>
        As described in our general Privacy Policy set forth above, clients
        (parents or schools operating as the agent of parents) can request to
        review any Personal Information collected about a child, have such
        information deleted, and/or request that there be no further collection
        or use of a child’s Personal Information. Adults with teacher or
        assessor access may remove children by deleting them from their
        assessment roster. Parents may do this by contacting the account holder
        associated with their child and requesting deletion. We take steps to
        confirm that anyone requesting Personal Information about a child is in
        fact the child’s parent or authorized school agent. Please keep in mind
        that a request to delete Personal Information about a child or a request
        that there no there be no further collection or use of their child’s
        Personal Information may lead to the termination of an account,
        membership or other service. Upon written request by a school, we will
        delete any Personal Information collected from children, and we will
        provide written verification that the information has been destroyed as
        requested.
        <br />
        If you no longer wish to have Personal Information of a child collected
        by an application installed on a mobile device, you may uninstall the
        application by using the standard uninstall processes available on the
        mobile device or via the mobile application marketplace or network.
      </p>
      <ol>
        <li>
          How We Protect Children’s Personal Information The technical,
          administrative, and physical security measures we employ to safeguard
          and help prevent unauthorized access to information we collect through
          our Services is described in our general <a href="">Privacy Policy</a>
          .
        </li>
        <li>Contact Us for anything around the Children’s Privacy Policy</li>
      </ol>
      <p>
        If you have questions or comments regarding this Children’s Privacy
        Policy, you may contact us using the information below:
      </p>
      <ul>
        <li>Contact Authority: Manager - Customer Support</li>
        <li>
          Address: G-72, Second Floor, South City-II, Gurugram -122018, Haryana,
          INDIA
        </li>
        <li>Email: play@empass.mobi</li>
        <li>Phone: +91 89881 33552</li>
      </ul>
    </>
  );
}
